import { NumberConverter } from '../converter/body/number-converter';

let _mpeg2Instance: CRC | undefined;

export class CRC {
  public static POLYNOMIAL_CRC32_MPEG2 = 0x4c11db7;
  public static MODULO = 4;

  public static FIRST_VALUE = 0xffffffff;

  static mpeg2() {
    if (!_mpeg2Instance) {
      _mpeg2Instance = new CRC(CRC.POLYNOMIAL_CRC32_MPEG2);
    }
    return _mpeg2Instance;
  }

  constructor(public readonly polynomial: number) {}

  public compute(
    buffer: Uint32Array | Uint8Array,
    firstValue: number = CRC.FIRST_VALUE,
  ) {
    if (buffer instanceof Uint32Array) {
      return CRC.fromWord(buffer, firstValue, this.polynomial);
    } else {
      return CRC.fromBytes(buffer, firstValue, this.polynomial);
    }
  }

  public static fromBytes(
    data: Uint8Array,
    crc = CRC.FIRST_VALUE,
    polynomial: number = CRC.POLYNOMIAL_CRC32_MPEG2,
  ): number {
    if (data.length % CRC.MODULO !== 0) {
      throw new Error(
        `Cannot compute CRC, input size must be a multiple of 4. Length is ${
          data.length
        } % ${CRC.MODULO} = ${data.length % CRC.MODULO}`,
      );
    }
    const uint32Data = new Uint32Array(data.length / 4);
    for (let offset = 0; offset < uint32Data.byteLength; offset++) {
      uint32Data[offset] = NumberConverter.fromOpaqueMsb(
        data.slice(offset * 4, (offset + 1) * 4),
        32,
      );
    }
    return CRC.fromWord(uint32Data, crc, polynomial);
  }

  // crc 32 calculation by word.
  public static fromWord(
    buffer: Uint32Array,
    crc = CRC.FIRST_VALUE,
    polynomial: number = CRC.POLYNOMIAL_CRC32_MPEG2,
  ): number {
    // don't follow null pointers
    if (!buffer) {
      throw new Error('Buffer is null');
    }
    // don't accept buffers larger than 16MB
    if (buffer.byteLength > 16 * 1024 * 1024) {
      throw new Error('Buffers larger than 16MB');
    }

    let myword: number;

    for (let i = 0; i < buffer.length; i++) {
      myword = buffer[i]; // Get next word.
      crc = CRC.appendCrcNumber(crc, myword, polynomial);
    }

    return crc;
  }

  static appendCrcNumber(crc: number, data: number, polynomial: number) {
    crc = crc ^ data;

    for (let i = 0; i < 32; i++) {
      if (crc & 0x80000000) {
        crc = ((crc << 1) ^ polynomial) >>> 0;
      } else {
        crc = (crc << 1) >>> 0;
      }
    }

    return crc;
  }
}
